export enum Role {
  SuperMonedas = 'SuperMonedas',
  Autonomo = 'Autonomo',
  Empleado = 'Empleado'
}
